// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.main-container[data-v-4a39df6e] {\n    margin: 10px 0em !important;\n}\n.manager-header[data-v-4a39df6e] {\n    font-weight: lighter !important;\n}\n", ""]);
// Exports
module.exports = exports;
